import React, { useEffect, useState } from "react";
import FirebaseService from "../../firebase";

const Pagos = () => {
  const [pagos, setPagos] = useState([]);
  const [filtro, setFiltro] = useState(""); // 🔹 Buscador
  const [imagenAmpliada, setImagenAmpliada] = useState(null);

  useEffect(() => {
    const unsubscribe = FirebaseService.db
      .collection("pagos")
      .orderBy("fechaPago", "desc")
      .onSnapshot(
        (snapshot) => {
          const pagosData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setPagos(pagosData);
        },
        (error) => console.error("❌ Error al obtener pagos:", error)
      );
    return () => unsubscribe();
  }, []);

  const validarPago = async (id) => {
    try {
      await FirebaseService.db.collection("pagos").doc(id).update({ pagado: true });
      console.log(`✅ Pago ${id} validado`);
    } catch (error) {
      console.error("❌ Error al validar pago:", error);
      alert("No se pudo validar el pago.");
    }
  };

  const eliminarPago = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar este pago?")) return;
    try {
      await FirebaseService.db.collection("pagos").doc(id).delete();
      console.log(`🗑️ Pago ${id} eliminado`);
    } catch (error) {
      console.error("❌ Error al eliminar pago:", error);
      alert("No se pudo eliminar el pago.");
    }
  };

  // 🔹 Filtrar pagos según búsqueda
  const pagosFiltrados = pagos.filter(
    (p) =>
      p.nombreUsuario?.toLowerCase().includes(filtro.toLowerCase()) ||
      p.idUsuario?.toString().includes(filtro) ||
      p.pedidoId?.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <div style={{ padding: 20 }}>
      <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: 20 }}>
        💳 Pagos recibidos
      </h1>

      {/* 🔹 Input de búsqueda */}
      <input
        type="text"
        placeholder="Buscar por usuario, ID o pedido..."
        value={filtro}
        onChange={(e) => setFiltro(e.target.value)}
        style={{
          padding: "8px 12px",
          marginBottom: 20,
          width: "100%",
          maxWidth: 400,
          borderRadius: 6,
          border: "1px solid #ccc",
        }}
      />

      {pagosFiltrados.length === 0 ? (
        <p>No hay pagos que coincidan con la búsqueda.</p>
      ) : (
        <table style={styles.table}>
          <thead style={{ backgroundColor: "#c8e6c9" }}>
            <tr>
              <th style={styles.th}>Fecha</th>
              <th style={styles.th}>Usuario</th>
              <th style={styles.th}>ID Usuario</th>
              <th style={styles.th}>Pedido ID</th>
              <th style={styles.th}>Cuota</th>
              <th style={styles.th}>Monto</th>
              <th style={styles.th}>Comprobante</th>
              <th style={styles.th}>Estado</th>
              <th style={styles.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {pagosFiltrados.map((pago) => (
              <tr key={pago.id}>
                <td style={styles.td}>
                  {pago.fechaPago?.toDate
                    ? pago.fechaPago.toDate().toLocaleString()
                    : "Sin fecha"}
                </td>
                <td style={styles.td}>{pago.nombreUsuario}</td>
                <td style={styles.td}>{pago.idUsuario}</td>
                <td style={styles.td}>{pago.pedidoId}</td>
                <td style={styles.td}>{pago.numeroCuota}</td>
                <td style={styles.td}>S/ {pago.montoPagado?.toFixed(2)}</td>
                <td style={styles.td}>
                  {pago.comprobanteUrl ? (
                    <img
                      src={pago.comprobanteUrl}
                      alt="Comprobante"
                      style={{ width: 60, height: 60, cursor: "pointer", borderRadius: 8 }}
                      onClick={() => setImagenAmpliada(pago.comprobanteUrl)}
                    />
                  ) : (
                    "No adjunto"
                  )}
                </td>
                <td style={styles.td}>{pago.pagado ? "✅ Validado" : "⏳ Pendiente"}</td>
                <td style={styles.td}>
                  <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                    {!pago.pagado && (
                      <button
                        onClick={() => validarPago(pago.id)}
                        style={{ backgroundColor: "#4caf50", color: "#fff", padding: "6px 10px", border: "none", borderRadius: 6, cursor: "pointer" }}
                      >
                        Validar
                      </button>
                    )}
                    <button
                      onClick={() => eliminarPago(pago.id)}
                      style={{ backgroundColor: "#e53935", color: "#fff", padding: "6px 10px", border: "none", borderRadius: 6, cursor: "pointer" }}
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Modal para mostrar imagen ampliada */}
      {imagenAmpliada && (
        <div style={styles.modalOverlay} onClick={() => setImagenAmpliada(null)}>
          <div style={styles.modalContent}>
            <img src={imagenAmpliada} alt="Comprobante ampliado" style={{ width: "100%", borderRadius: 10 }} />
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  table: { width: "100%", borderCollapse: "collapse", backgroundColor: "#fff", borderRadius: 10, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" },
  th: { padding: 10, border: "1px solid #ccc", textAlign: "center", fontWeight: "bold" },
  td: { padding: 8, border: "1px solid #eee", textAlign: "center" },
  modalOverlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
  modalContent: { backgroundColor: "#fff", padding: 10, borderRadius: 10, width: "80%", maxWidth: 500 },
};

export default Pagos;


